import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);

const stockColumnsDefinitions = ({ dateFormat = 'DD.MM.YYYY' } = {}) => {
  const safeDateFormatter = (params) => {
    const value = params?.value ?? params;
    if (value === null || value === undefined || value === '') return '';
    const d = dayjs(value);
    if (!d.isValid()) return '';
    return d.format(dateFormat);
  };

  return [
    {
      field: 'date',
      headerName: 'Date',
      width: 150,
      valueFormatter: safeDateFormatter,
    },
    {
      field: 'calendarWeek',
      headerName: 'CW',
      description: 'Calendar Week',
      width: 130,
      valueGetter: (_value, row) => {
        const date = row.date;
        if (date == null) return '';
        const d = dayjs(date);
        return d.isValid() ? d.isoWeek() : '';
      },
    },
    { field: 'currentStock', headerName: 'Current Stock', width: 150 },
    { field: 'forecastInflow', headerName: 'Forecast Inflow', width: 150 },
    { field: 'actualInflow', headerName: 'Actual Inflow', width: 150 },
    { field: 'totalBlockedCars', headerName: 'Total Blocked Cars', width: 150 },
    { field: 'readyForShipment', headerName: 'Ready For Shipment', width: 150 },
    { field: 'marketName', headerName: 'Market Name', width: 150 },
    { field: 'marketId', headerName: 'Market ID', width: 150 },
    {
      field: 'destinationPortName',
      headerName: 'Destination Port Name',
      width: 150,
    },
    {
      field: 'destinationPortUnLocode',
      headerName: 'Destination Port UnLocode',
      width: 150,
    },
    {
      field: 'departurePortName',
      headerName: 'Departure Port Name',
      width: 150,
    },
    {
      field: 'departurePortUnLocode',
      headerName: 'Departure Port UnLocode',
      width: 150,
    },
    { field: 'portOperatorName', headerName: 'Port Operator Name', width: 200 },
    { field: 'portOperatorNo', headerName: 'Port Operator No', width: 150 },
    { field: 'version', headerName: 'Version', width: 100 },
    { field: 'changed', headerName: 'Changed', width: 100 },
    {
      field: 'updatedAt',
      headerName: 'Updated At',
      width: 200,
      valueFormatter: safeDateFormatter,
    },
    { field: 'updatedBy', headerName: 'Updated By', width: 200 },
  ];
};

export default stockColumnsDefinitions;
